import axios from "axios";
import * as Toastr from "toastr";

import { InitPage } from "../index";
import Cookies from "js-cookie";

declare let pinURL: any;

class PinAuthentication {
  constructor() {
    let event = null;
    $("document").ready(function () {
      $(".enter-pin").on("click", function (e) {
        event = e;
        e.preventDefault();
        $("#pin-dialog").modal("show");
        $('input[name="pin"]').val('');
      });

      $("#pin-login").on("click", function () {
        const pin = $("#pin").val();
        axios
          .post(pinURL, { pin })
          .then(function () {
            Cookies.set("pin", pin);
            if (event) {
              window.location.href = event.target.href;
              event = null;
            }
          })
          .catch((error) => {
            Toastr.error(error.response.data.message);
          });
      });
    });
  }
}

export function LoadPage() {
  InitPage("returns", () => new PinAuthentication());
  InitPage("schedules", () => new PinAuthentication());
}
